import { useQuery } from '@tanstack/react-query';
import { killshotApi } from '../api';

const fetchSBEventMeta = async skyboxId => {
  const response = await killshotApi.get(`v1/event/${skyboxId}`);
  return response;
};

export const useQueryEvents = eventId => {
  const { data, isFetching, status, error, refetch } = useQuery({
    queryKey: [`/event/${eventId}`],
    queryFn: () => fetchSBEventMeta(eventId),
    refetchOnWindowFocus: false,
    enabled: !!eventId,
    refetchOnMount: true,
  });
  return {
    data,
    isFetching,
    status,
    error,
    refetch,
  };
};
